const LEGACY_PLATFORM_SUFFIX = '.site.coveauto.ai';
const NEXT_PLATFORM_SUFFIX = '.site.cove-page.com';
const PLATFORM_SITE_KEY_PREFIX = 'site-';

const normalizeHostCandidate = (value: string) =>
  value
    .trim()
    .replace(/^[a-z]+:\/\//i, '')
    .replace(/[/?#].*$/, '')
    .replace(/\/+$/g, '');

export const normalizeLegacyPlatformHost = (host?: string | null) => {
  const normalizedHost = normalizeHostCandidate(String(host || ''));
  if (!normalizedHost) return '';

  if (/^site-[a-z0-9-]+$/i.test(normalizedHost)) {
    return `${normalizedHost}${NEXT_PLATFORM_SUFFIX}`;
  }

  return normalizedHost.replace(
    new RegExp(`${LEGACY_PLATFORM_SUFFIX.replace(/\./g, '\\.')}$`, 'i'),
    NEXT_PLATFORM_SUFFIX,
  );
};

export const normalizeLegacyPlatformUrl = (url?: string | null) => {
  const rawUrl = String(url || '').trim();
  if (!rawUrl) return '';

  try {
    const parsed = new URL(rawUrl);
    parsed.host = normalizeLegacyPlatformHost(parsed.host) || parsed.host;
    return parsed.toString();
  } catch {
    return rawUrl.replace(/\.site\.coveauto\.ai(?=[:/?#]|$)/i, NEXT_PLATFORM_SUFFIX);
  }
};

const addTrailingPathSlash = (value: string) => {
  const hashIndex = value.indexOf('#');
  const withoutHash = hashIndex >= 0 ? value.slice(0, hashIndex) : value;
  const hash = hashIndex >= 0 ? value.slice(hashIndex) : '';
  const queryIndex = withoutHash.indexOf('?');
  const path = queryIndex >= 0 ? withoutHash.slice(0, queryIndex) : withoutHash;
  const query = queryIndex >= 0 ? withoutHash.slice(queryIndex) : '';

  return `${path.endsWith('/') ? path : `${path}/`}${query}${hash}`;
};

export const normalizeLegacyPlatformUrlWithTrailingSlash = (url?: string | null) => {
  const normalizedUrl = normalizeLegacyPlatformUrl(url);
  if (!normalizedUrl) return '';

  try {
    const parsed = new URL(normalizedUrl);
    if (!parsed.pathname.endsWith('/')) {
      parsed.pathname = `${parsed.pathname}/`;
    }
    return parsed.toString();
  } catch {
    return addTrailingPathSlash(normalizedUrl);
  }
};

export const normalizeLegacyPlatformDomain = (value?: string | null) => {
  const rawValue = String(value || '').trim();
  if (!rawValue) return '';

  if (/^https?:\/\//i.test(rawValue)) {
    return normalizeLegacyPlatformUrl(rawValue)
      .replace(/^https?:\/\//i, '')
      .replace(/\/+$/g, '');
  }

  return normalizeLegacyPlatformHost(rawValue);
};

export const isPlatformSiteKey = (value?: string | null) =>
  String(value || '')
    .trim()
    .toLowerCase()
    .startsWith(PLATFORM_SITE_KEY_PREFIX);
